// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import InitializeCashReportsGql from '@/extensions/shop/pointOfSale/store/graphql/queries/InitializeCashReports.gql';
import CreateCashReportsGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/CreateCashReports.gql';

import { parseInt } from 'lodash';

export default {
    initializeCashReports: (pointOfSaleID) =>
        new Promise((resolve, reject) => {
            let variables = {
                pointOfSale: parseInt(pointOfSaleID),
                includeAllPaymentMethods: true
            };

            apolloClient
                .query({
                    query: InitializeCashReportsGql,
                    variables,
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_POS_InitializeCashReports))
                .catch((err) => reject(err));
        }),
    createCashReports: (pointOfSale, cashReports) => {
        if (pointOfSale === undefined || cashReports === undefined) {
            throw new Error('required argument is missing')
        }

        pointOfSale = _.removeDeepByKey(pointOfSale, '__typename')
        cashReports = _.removeDeepByKey(cashReports, '__typename')

        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: CreateCashReportsGql,
                variables: {
                    pointOfSale,
                    cashReports,
                }
            })
                .then(({data}) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_CreateCashReports)
                })
                .catch(err => reject(err))
        })
    }
};
